import { ICase } from "../types/case/case";

export const permissionsCase = (caseAgency: string, agencyCode: string, casesCrossBorder: string[] = []) => {
  return !!(caseAgency === agencyCode
    || agencyCode === "ALL"
    || (casesCrossBorder && casesCrossBorder.find((agency) => agency === agencyCode)))
}

export const isAnETLCase = (caseData: ICase) => {
  return !!caseData.etl
}


// WEBPACK FOOTER //
// ./src/share/utils/permissionsCase.ts